// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gray {
  color: #292727;
}

.search-result {
  display: block;
  width: 100%;
  text-align: left;
  font: inherit;
  background: none;
  border: none;
  padding: 0.5rem 1rem;
  cursor: pointer;
}
.search-result:hover {
  background-color: #e9e9e9;
}
.search-result:focus {
  outline: revert;
}
.search-result .search-result-row {
  display: flex;
  flex-flow: row;
}
.search-result .summary {
  grid-area: summary;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-weight: 600;
  flex: 1 1 100%;
  margin-right: 0.5rem;
}
.search-result .summary * {
  display: inline;
}
.search-result .description {
  grid-area: description;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  flex: 1 1 100%;
  margin-right: 0.5rem;
  height: 2rem;
}
.search-result .description * {
  display: inline;
  margin: 0;
  padding: 0;
}
.search-result .start {
  grid-area: start;
  overflow: hidden;
  white-space: nowrap;
  text-align: right;
  flex: 0 0 auto;
}
.search-result .type {
  grid-area: type;
  overflow: hidden;
  white-space: nowrap;
  text-align: right;
  flex: 0 0 auto;
}

.description h1,
.description h2,
.description h3,
.description h4,
.description h5,
.description h6,
.description .h1,
.description .h2,
.description .h3,
.description .h4,
.description .h5,
.description .h6 {
  font-size: inherit;
}`, "",{"version":3,"sources":["webpack://./src/Styles/Colors.scss","webpack://./src/Components/Layout/ApplicationNavigation/Search/SearchResult.scss"],"names":[],"mappings":"AAsCA;EACE,cArCU;ACAZ;;AAAA;EACE,cAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,YAAA;EACA,oBAAA;EACA,eAAA;AAGF;AADE;EACE,yBDCa;ACEjB;AAAE;EACE,eAAA;AAEJ;AACE;EACE,aAAA;EACA,cAAA;AACJ;AAEE;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;EACA,oBAAA;AAAJ;AACI;EACE,eAAA;AACN;AAGE;EACE,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,oBAAA;EACA,YAAA;AADJ;AAEI;EACE,eAAA;EACA,SAAA;EACA,UAAA;AAAN;AAIE;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;AAFJ;AAKE;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;AAHJ;;AAOA;;;;;;;;;;;;EAYE,kBAAA;AAJF","sourcesContent":["// Define colors here to use across the site\n\n$textColor: #292727;\n$darkTextColor: #696969;\n$lightTextColor: #cacacb;\n$black: black;\n$borderColor: #c0c0c0;\n$gridBorderColor: #ddd;\n$hoverColor: #b8b8b8;\n$shadow: #9c9c9c;\n$gray: #efefef;\n$darkGray: #515554;\n$backgroundColor: #ffffff;\n$backgroundRight: #ffffff;\n$backgroundLeft: #e9e9e9;\n$success: #18b100;\n$headingsGray: #333333;\n$camelGold: #d0ad4d;\n$gold: #dabc64;\n$iconColor: #9c9c9c;\n$navIcon: #4d4d4d;\n$navIconActive: #dabc64;\n$iconColorActive: #dabc64;\n$magenta: #ab3a72;\n$habitPrimary: rgb(51, 51, 51);\n$habitBorder: rgb(208, 213, 221);\n$habitActionText: rgb(86, 86, 86);\n$habitActionIcon: #565656;\n\n// Brands\n$brand-primary: #3097d1;\n$brand-info: #8eb4cb;\n$brand-success: #2ab27b;\n$brand-warning: #cbb956;\n$brand-danger: red;\n\n$orange: #f5a000;\n\n.gray {\n  color: $textColor;\n}\n\n$input-color: #555;\n\n$headingColor: #999;\n$dayHeadingColor: #555;\n$undoBackground: #bdbdbd;\n","@import 'Colors.scss';\n\n.search-result {\n  display: block;\n  width: 100%;\n  text-align: left;\n  font: inherit;\n  background: none;\n  border: none;\n  padding: 0.5rem 1rem;\n  cursor: pointer;\n\n  &:hover {\n    background-color: $backgroundLeft;\n  }\n\n  &:focus {\n    outline: revert;\n  }\n\n  .search-result-row {\n    display: flex;\n    flex-flow: row;\n  }\n\n  .summary {\n    grid-area: summary;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    font-weight: 600;\n    flex: 1 1 100%;\n    margin-right: 0.5rem;\n    * {\n      display: inline;\n    }\n  }\n\n  .description {\n    grid-area: description;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    flex: 1 1 100%;\n    margin-right: 0.5rem;\n    height: 2rem;\n    * {\n      display: inline;\n      margin: 0;\n      padding: 0;\n    }\n  }\n\n  .start {\n    grid-area: start;\n    overflow: hidden;\n    white-space: nowrap;\n    text-align: right;\n    flex: 0 0 auto;\n  }\n\n  .type {\n    grid-area: type;\n    overflow: hidden;\n    white-space: nowrap;\n    text-align: right;\n    flex: 0 0 auto;\n  }\n}\n\n.description h1,\n.description h2,\n.description h3,\n.description h4,\n.description h5,\n.description h6,\n.description .h1,\n.description .h2,\n.description .h3,\n.description .h4,\n.description .h5,\n.description .h6 {\n  font-size: inherit;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
